export const contractsTableStyles = {
  header: {
    fontSize: 14,
    padding: 10,
    color: '#1a171b',
    backgroundColor: 'rgba(0, 65, 101, 0.1)',
    border: 'none',
  },
  cell: {
    fontSize: 13,
    color: '#63666a',
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
